const set = (label, obj) => window.localStorage.setItem(label, JSON.stringify(obj))
const get = (label) => JSON.parse(window.localStorage.getItem(label))
const remove = (label) => window.localStorage.removeItem(label)

export { set, get, remove }